module.exports = __webpack_public_path__ + "static/media/newslettersIcon-darkc.3e227655.png";